<template>
  <div class="container">
    <div class="panal mt-20">
      <div class="panal-header">Select Event</div>
      <div class="panal-body">
   
<div class="mt-3 ">
  <b-card-group v-if="empty">
    <p class="text-danger"> No Data</p>
  </b-card-group>
<div class="row mb-3" v-else>
    <b-card-group  v-for="(item, index) in selectEvent" v-bind:key="index" class="col-md-4 col-sm-12 mb-3">
        
      <b-card bg-variant="light" :header="item.NameEN" class="text-center w-100">
        <b-card-text>
     <strong>
            Date: {{item.StartDate | moment("ll") }} to  {{item.EndDate | moment("ll") }}<br/>
            Government : {{item.Address}}<br/>
            Status : {{item.EventStatus ? item.EventStatus= item.EventStatus: '--' }}
      </strong>
      </b-card-text>
              <b-button href="#" variant="primary" @click="goToEvent(item.Serial)">Go Event</b-button>
            </b-card>
   



    </b-card-group>
     
     </div>
</div>


      </div>
    </div>
  </div>
</template>

<script>

import EventServiceSelect from '../../services/Event/event.services'


export default {
  name: "SelectEvent",
  data() {
    return {
      message:'',
      isLoading : true, 
      empty:false,
      selectEvent: [], 
      getAllData: [], 
      Serial: ''
    };
  },
  // beforeCreate() {
  //    EventServiceSelect.SelectMarketingEvent(6).then(Response =>{
  //            //  this.isLoading = false ;
  //              this.getAllData = Response.data
  //              this.empty =false
  //               // eslint-disable-next-line no-console
  //               //console.log('getAllData => ',this.getAllData)
  //          }, error => {
  //             this.empty = true
  //                 // eslint-disable-next-line no-console
  //                // console.log(error.response.status)
                 
  //             this.message =
  //               (error.response && error.response.data && error.response.data.Message) ||
  //               error.message ||
  //               error.toString();
                
  //               if(error.response.status == 404) this.message =''
             
  //           }) 
  // },
  mounted(){
      // EventServiceSelect.SelectMarketingEvent(6).then(Response =>{
        EventServiceSelect.SelectMarketing_AllEvents().then(Response =>{
             //  this.isLoading = false ;
               this.selectEvent = Response.data
               this.empty =false
                // eslint-disable-next-line no-console
              //  console.log('selectEvent => ',this.selectEvent)
           }, error => {
              this.empty = true
                  // eslint-disable-next-line no-console
                 // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 
  },
  methods:{
   goToEvent(Serial){
     this.Serial = Serial;
      // eslint-disable-next-line
    
   this.$router.push('/event/'+Serial); 
      }
  }
};
</script>

<style scoped>
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #50bd77;
}
table tr th {
  background-color: #4caf5000 !important;
  color: #333;
  font-weight: bold;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}

.divider {
  *width: 100%;
  height: 1px;
  margin: 9px 1px;
  *margin: -5px 0 5px;
  overflow: hidden;
  /* background-color: #e5e5e5; */
  border-bottom: 1px dotted #e5e5e5;
}
.su-border {
  border-color: #3d8fe3 !important;
  background: #f1f9ff !important;
}
.panal-body {
  padding: 20px;
  color: #333;
}
.app-stu-photo {
  float: right;
  width: 200px;
  border-radius: 10px;
  border: 1px solid #111;
  margin-top: 20px;
}
.app-stu-photo img {
  width: 100%;
  border-radius: 10px;
}
.app-All {
  width: 80%;
  float: left;
}
.app-stu {
  border-bottom: 1px #333 dotted;
  padding: 10px 0px;
}
.app-stu .title {
  font-weight: bold;
}

.app-stu .title span {
  font-weight: 100;
}

.table .thead-light th {
  font-size: 14px !important;
}
.table .thead-light th {
  font-size: 14px !important;
  background-color: #eaeaea !important;
}

.panal2 {
  background: #eee;
  border-radius: 10px;
  color: #333;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header2 {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body2 {
  padding: 20px;
  color: #333;
}
.mt-10 {
  margin-top: 10px;
}

.btn {
  margin-left: 5px;
}
</style>